import React, { useState, useEffect } from 'react';
import {
  formatPrice,
  KTSVG,
  LoadingGrid,
  TableList,
} from '../../../../rbts/helpers';
import { Modal } from 'react-bootstrap-v5';
import { useGetAllDonationsDetailList } from '../hooks/DonationsHook';
type Props = {
  show: boolean;
  handleClose: (updateGrid: boolean) => void;
  id: number;
};

const DetailModal: React.FC<Props> = ({ id, show, handleClose }) => {
  const [reloadGrid, setReloadGrid] = useState<number>(Math.random() * 40);
  const { listDonationsDetail, loadingRequest } = useGetAllDonationsDetailList(
    reloadGrid,
    id
  );

  const columns: any = [
    {
      id: 'producto',
      name: <div className="fw-bolder text-muted me-5 ">Producto </div>,
      selector: (row: any) => (row.producto ? row.producto.nombre : 'N/A'),
      cell: (row: any) => (
        <>
          {row.producto ? (
            <>
              <div className="fw-bolder">{row.producto.nombre}</div>
            </>
          ) : (
            <div className="fw-bolder">{row.descripcion}</div>
          )}
        </>
      ),
      sortable: true,
      width: '20%',
    },
    {
      id: 'tipo',
      name: <div className="fw-bolder text-muted me-5">Tipo</div>,
      selector: (row: any) => (row.tipo ? row.tipo : 'N/A'),
      cell: (row: any) => (
        <>
          <span
            className={` badge ${
              row.tipo === 'materia_prima_compra'
                ? 'badge-success'
                : 'badge-info'
            }`}
          >
            {row.tipo === 'materia_prima_compra' ? 'Compra' : 'Donativo'}
          </span>
        </>
      ),
      sortable: false,
      width: '20%',
    },
    {
      id: 'proveedor',
      name: <div className="fw-bolder text-muted me-5">Proveedor</div>,
      selector: (row: any) => (row.proveedor ? row.proveedor.nombre : 'N/A'),
      sortable: false,
      width: '20%',
    },
    {
      id: 'precio_pactado',
      name: <div className="fw-bolder text-muted me-5 ">Precio pactado</div>,
      selector: (row: any) => row.monto,
      cell: (row: any) => (
        <>
          <div className="fw-bolder">
            {formatPrice(row.monto ? row.monto : 0, 'es-MX', 'MXN', 2, 2)}
          </div>
        </>
      ),
      sortable: true,
      width: '20%',
    },
    {
      id: 'cantidad',
      name: <div className="fw-bolder text-muted me-5 ">Cantidad</div>,
      selector: (row: any) => row.cantidad,
      cell: (row: any) => (
        <>
          {row.cantidad ? (
            <>
              <div className="fw-bolder">{row.cantidad}</div>
            </>
          ) : (
            <div className="text-muted">-</div>
          )}
        </>
      ),
      sortable: true,
      width: '20%',
    },
  ];

  return (
    <Modal
      id="kt_modal_create"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-1000px"
      show={show}
      onHide={() => {
        handleClose(false);
      }}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>Detalle de la operación</h2>
          <div
            className="btn btn-sm btn-icon btn-active-color-primary"
            onClick={() => {
              handleClose(false);
            }}
          >
            <KTSVG
              className="svg-icon-2"
              path="/media/icons/duotune/arrows/arr061.svg"
            />
          </div>
        </div>
        <div className="modal-body scroll-y mx-5 ">
          <div className="row gy-5 g-xl-8">
            <div className="col-xl-12">
              {loadingRequest ? (
                <LoadingGrid text="Cargando..."></LoadingGrid>
              ) : (
                <TableList
                  data={listDonationsDetail}
                  columns={columns}
                ></TableList>
              )}
            </div>
          </div>
          <div className="text-center pt-15">
            <button
              type="reset"
              className="btn btn-light me-3"
              data-kt-users-modal-action="cancel"
              onClick={() => {
                handleClose(false);
              }}
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
export { DetailModal };
